export const tableTexts = [
  {
    header: 'Feel better fast',
    items: [
      {
        text: 'Simple actionable recommendations daily baby steps that guide you toward better health',
        allowInFree: false,
      },
      {
        text: 'Recommendations get sciencebacked tips to beat insomnia cure a hangover stop a panic attack get rid of a headache or get blood pressure under control',
        allowInFree: false,
      },
      {
        text: 'Personalized research papers based on your data insights into how your lifestyle impacts your health and what you can do about it',
        allowInFree: false,
      },
      {
        text: 'Personalized move goals your move stand and exercise data will let you know whether youre doing enough to support your health',
        allowInFree: false,
      },
      {
        text: 'Breathing practices focus or unwind when you need it most with guided practices backed by science',
        allowInFree: true,
      },
    ],
  },
  {
    header: 'Gain rich health insights',
    items: [
      {
        text: 'Detailed heartbeat analytics your stress energy and focus scores tons of metrics and charts  all for you to see how your body is doing and spot the changes',
        allowInFree: false,
      },
      {
        text: 'An indepth blood pressure analysis enter your numbers and we will provide five extra indexes give detailed interpretations and alert you if something does not look right',
        allowInFree: false,
      },
      {
        text: 'Blood pressure reports send your data to your doctor or print out neat reports with all your readings',
        allowInFree: false,
      },
      {
        text: 'Basic heartbeat analytics just your stress energy and focus scores no extra metrics',
        allowInFree: true,
      },
      {
        text: 'Basic blood pressure analysis we will interpret your top and bottom numbers without extra indexes',
        allowInFree: true,
      },
      {
        text: 'Yesterdays heart report sent to your feed daily it will show how your heart rate changed throughout the day depending on what you were doing',
        allowInFree: true,
      },
    ],
  },

  {
    header: 'Gain self-awareness',
    items: [
      {
        text: 'Detailed heartbeat analytics your stress energy and focus scores tons of metrics and charts  all for you to see how your body is doing and spot the changes',
        allowInFree: false,
      },
      {
        text: 'Lifelogging track your calls meetings and nights out in your feed to see how they impact your wellbeing',
        allowInFree: false,
      },
      {
        text: 'Smarter geotracking find out how the time you spend at home in the office on the road or in your favorite bars and cafes affects your health and mood',
        allowInFree: false,
      },
      {
        text: 'Access to all clinically validated tests learn more about your health and lifestyle and check if you are addicted to food or gadgets',
        allowInFree: true,
      },
      {
        text: 'Hundreds of charts featuring your Apple Health Google Fit and Samsung Health data',
        allowInFree: true,
      },
      {
        text: 'Basic workout analytics based on your Apple Health Google Fit and Samsung Health data',
        allowInFree: true,
      },
      {
        text: 'Basic selfmonitoring add tags weight and blood pressure manually and fill out mood and health askers',
        allowInFree: true,
      },
    ],
  },
];
